// extracted by mini-css-extract-plugin
export default {"chipExpired":"boleto-status_chipExpired__X-G1I","chipPaid":"boleto-status_chipPaid__By2NG","chipPending":"boleto-status_chipPending__zwlcC"};